export default __webpack_public_path__ + "static/media/checked.9eb9306f.svg";